<template>
    <app-layout>
        <template #header>
            <div class="relative">
                <div class="absolute top-0 right-0">
                    <inertia-link
                        class="bg-gray-300 hover:bg-gray-500 text-black py-1 px-3 mx-3 rounded my-0"
                        :href="route(routeBack)">
                        <i class="fas fa-arrow-left mx-1"></i> Voltar
                    </inertia-link>
                    <button @click="create()"
                            class="bg-green-500 text-sm hover:bg-green-700 text-white text-base font-bold my-0 -mt-10 py-3 px-6 rounded">
                        <i class="fas fa-save mx-1"></i>
                        Salvar
                    </button>
                    <button @click="removalConfirm=true"
                            v-if="contact"
                            class="bg-red-500 text-sm hover:bg-red-700 text-white text-base font-bold my-0 -mt-10 py-3 px-6 rounded">
                        <i class="fas fa-trash mx-1"></i>
                    </button>
                </div>
                <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                    Gerenciar meus cadastros
                </h2>
            </div>
        </template>
        <div>
            <div class="max-w-7xl mx-auto py-10 sm:px-6 lg:px-8">
                <flash :timeout="5000"/>

                <template>
                    <jet-form-section>
                        <template #title>
                            Informações de contato
                        </template>

                        <template #description>
                            Preencha corretamente os dados do cadastro
                        </template>

                        <template #form>
                            <div class="col-span-4 sm:col-span-3">
                                <jet-label for="contact_federal_document" value="Documento (CPF/CNPJ)"/>
                                <jet-fetch-doc
                                    id="contact_federal_document"
                                    type="text" class="mt-1 block w-full"
                                    v-model="form.federal_document"
                                    :target="fetchDoc"/>
                                <jet-input-error :message="form.error('federal_document')" class="mt-2"/>
                            </div>
                            <div class="col-span-2 sm:col-span-3 text-right pt-8"></div>
                            <div class="col-span-6 sm:col-span-6">
                                <jet-label for="contact_name" value="Nome"/>
                                <jet-input id="contact_name" type="text"  class="mt-1 block w-full"
                                           v-model="form.name"/>
                                <p class="text-sm text-red-600" v-if="(form.name != null)?form.name.length > 50:false">O nome do sacado ultrapassou o limite de 50 caracteres. Abrevie o nome para que este se enquadre nas regras de emissão de boleto. {{form.name.length}} </p>
                                <jet-input-error :message="form.error('name')" class="mt-2"/>
                            </div>
                        </template>
                    </jet-form-section>

                    <jet-section-border/>

                    <jet-form-section>
                        <template #title>
                            Contas de transferência
                        </template>

                        <template #description>
                            Informe as contas para transferência bancária
                        </template>

                        <template #form>
                            <div class="col-span-6 sm:col-span-6">
                                <div class="col-span-6">
                                    <div class="grid grid-cols-9 gap-4">
                                        <jet-label class="col-span-2" value="Tipo"/>
                                        <jet-label :class="(newAccount.type == 'PIX'?'col-span-2':'col-span-3')" :value="(newAccount.type == 'PIX'?'Tipo de Chave':'Banco')"/>
                                        <jet-label :class="(newAccount.type == 'PIX'?'col-span-4':'')" :value="(newAccount.type == 'PIX'?'Chave':'Agência')"/>
                                        <jet-label class="col-span-2" value="Conta" v-if="newAccount.type != 'PIX'" />
                                        <jet-label class="" value="Ações"/>
                                    </div>
                                    <div class="grid grid-cols-9 gap-4 mb-2">
                                        <jet-auto-complete
                                            :key="'accountType'"
                                            class="mt-1 col-span-2"
                                            v-model="newAccount.type"
                                            :options-list="['Corrente', 'Poupança', whiteLabelShortName,'PIX']"
                                        />
                                        <div class="grid grid-cols-6 gap-4 col-span-6"  v-if="newAccount.type != 'PIX'">
                                            <jet-auto-complete
                                                :key="'accountBank'"
                                                class="mt-1 w-full col-span-3"
                                                :optionsList="getBanks"
                                                v-model="newAccount.bank"
                                            />
                                            <jet-masked-input
                                                :mask="['####']"
                                                type="text" class="h-10 mt-1 block w-full"
                                                v-model="newAccount.agency"/>

                                            <jet-masked-input
                                                :mask="['###-#', '####-#', '#####-#', '######-#', '#######-#', '########-#', '#########-#', '##########-#', '###########-#', '############-#', '############-#']"
                                                type="text" class="w-full mt-1 col-span-2"
                                                v-model="newAccount.number"/>
                                        </div>
                                        <!-- Inputs Pix -->
                                        <div v-else  class="grid grid-cols-6 gap-4 col-span-6">
                                            <jet-auto-complete
                                                :key="'pixType'"
                                                class="mt-1 w-full col-span-2"
                                                v-model="newAccount.typeKey"
                                                :options-list="['CPF', 'CNPJ','E-mail','Celular','Aleatória']"
                                            />

                                            <jet-masked-input
                                                v-if="newAccount.typeKey != 'E-mail'"
                                                :mask="keyMask"
                                                type="text" class="w-full mt-1 col-span-4"
                                                v-model="newAccount.key"/>

                                             <jet-input
                                                v-else
                                                type="email" class="w-full mt-1 col-span-4"
                                                v-model="newAccount.key"/>
                                        </div>
                                        <jet-button class="mt-1 bg-green-500 text-white cursor-pointer text-center"
                                                    @click.native="addAccount">
                                            <i class="fas mx-auto fa-plus-circle fa-1_5x" v-show="!validating"/>
                                            <i class="fas mx-auto fa-spin fa-spinner fa-1_5x" v-show="validating"/>
                                        </jet-button>
                                        <jet-input v-model="newAccount.name"
                                                   placeholder="Apelido da conta"
                                                   class="col-span-8"/>
                                    </div>
                                    <div
                                        v-for="(account, index) in form.transfer_accounts" :key="index"
                                        class="grid grid-cols-9 gap-0">
                                        <div class="col-span-8 px-3 py-1 border-b border-gray-300">
                                            <div v-if="account.type != 'PIX'">
                                                <span v-if="account.name"> Conta {{ account.type }} - {{ account.name }} - </span>
                                                <span v-else> Conta {{ account.type }} - </span>
                                                <span class="text-xs">{{ account.bank ? account.bank.name : null }}</span>
                                                <br/>
                                                <span class="font-bold">Agência: </span> {{ account.agency }} -
                                                <span class="font-bold">Conta: </span> {{ account.number }}
                                            </div>
                                            <div v-else>
                                                <span v-if="account.name"> Conta {{ account.type }} - {{account.typeKey }} - {{ account.name }}</span>
                                                <span v-else> Conta {{ account.type }} - {{account.typeKey }}</span>
                                                <br/>
                                                <span class="font-bold">Chave: </span> {{ account.key }}
                                            </div>
                                        </div>
                                        <div class="pt-4 py-1 text-center border-b border-gray-300">
                                            <i class="fas fa-trash text-red-500 cursor-pointer"
                                               @click="removeAccount(index)"/>
                                        </div>

                                    </div>
                                </div>
                            <jet-input-error :message="form.error('transfer_accounts')" class="mt-2"/>
                            </div>
                        </template>
                    </jet-form-section>

                    <jet-section-border/>

                    <jet-form-section>
                        <template #title>
                            Endereço de cobrança
                        </template>

                        <template #description>
                            Complete os dados do endereço de cobrança
                        </template>

                        <template #form>
                            <div class="col-span-4 sm:col-span-3">
                                <jet-label for="address_zip_code" value="CEP"/>
                                <jet-fetch-cep
                                    id="address_zip_code"
                                    type="text" class="mt-1 block w-full"
                                    v-model="form.address.zip_code"
                                    :target="fetchCep"/>
                                <jet-input-error :message="form.error('address_zip_code')" class="mt-2"/>
                            </div>
                            <div class="col-span-6 sm:col-span-5">
                                <jet-label for="address_street_name" value="Logradouro"/>
                                <jet-input id="address_street_name" type="text" class="mt-1 block w-full"
                                           v-model="form.address.street"/>
                                <jet-input-error :message="form.error('address.street')" class="mt-2"/>
                            </div>
                            <div class="col-span-2 sm:col-span-1">
                                <jet-label for="address_street_number" value="Número"/>
                                <jet-input id="address_street_number" type="text" class="mt-1 block w-full"
                                           v-model="form.address.number"/>
                                <jet-input-error :message="form.error('address.number')" class="mt-2"/>
                            </div>
                            <div class="col-span-8 sm:col-span-6">
                                <jet-label for="address_addr_complement" value="Complemento"/>
                                <jet-input id="address_addr_complement" type="text" class="mt-1 block w-full"
                                           v-model="form.address.complement"/>
                                <jet-input-error :message="form.error('address_complement')" class="mt-2"/>
                            </div>
                            <div class="col-span-4 sm:col-span-3">
                                <jet-label for="address_neighborhood" value="Bairro"/>
                                <jet-input id="address_neighborhood" type="text" class="mt-1 block w-full"
                                           v-model="form.address.neighborhood"/>
                                <jet-input-error :message="form.error('address.neighborhood')" class="mt-2"/>
                            </div>
                            <div class="col-span-6 sm:col-span-2">
                                <jet-label for="address_city" value="Cidade"/>
                                <jet-input id="address_city" type="text" class="mt-1 block w-full"
                                           v-model="form.address.city"/>
                                <jet-input-error :message="form.error('address.city')" class="mt-2"/>
                            </div>
                            <div class="col-span-2 sm:col-span-1">
                                <jet-label for="address_state" value="UF"/>
                                <jet-auto-complete
                                    id="type"
                                    :options-list="stateList"
                                    :auto-load="true"
                                    class="mt-1 block w-full"
                                    v-model="form.address.state"/>
                                <jet-input-error :message="form.error('address.state')" class="mt-2"/>
                            </div>
                        </template>
                    </jet-form-section>

                    <jet-section-border />

                    <operating-limits v-show="false" :form="form" :formError.sync="errorOp" v-if="$page.props.user.scope === 'admin'" />
                </template>
                <confirmation-modal :show="removalConfirm" @close="removalConfirm=false">
                    <template #title>
                        Remover cadastro
                    </template>
                    <template #content>
                        Você confirma a remoção de {{ form.name }}
                    </template>
                    <template #footer>
                        <jet-secondary-button @click.native="removalConfirm = false">
                            Agora não
                        </jet-secondary-button>
                        <ok-button @click.native="remove">Remover</ok-button>
                    </template>
                </confirmation-modal>

                <confirmation-modal :show="contactFound.id" @close="contactFound.id=null">
                    <template #title>
                            Editar contato
                    </template>
                    <template #content>
                        {{ form.name }} é um favorecido cadastrado para sua conta. Você deseja editá-lo?
                    </template>
                    <template #footer>
                        <jet-secondary-button
                            @click.native="contactFound.id=null;form.name = null; form.name = ''; form.federal_document = '';">
                            Agora não
                        </jet-secondary-button>
                        <ok-button @click.native="editContact">Editar</ok-button>
                    </template>
                </confirmation-modal>

                <confirmation-modal :show="invalidOwnership" @close="invalidOwnership=false">
                    <template #title>
                        Conta incorreta
                    </template>
                    <template #content>
                        {{ accountFound.message }}
                    </template>
                    <template #footer>
                        <jet-secondary-button
                            @click.native="resetAccount">
                            Fechar
                        </jet-secondary-button>
                    </template>
                </confirmation-modal>
            </div>
        </div>
    </app-layout>
</template>

<script>
import AppLayout from './../../Layouts/AppLayout'
import JetSectionBorder from './../../Jetstream/SectionBorder'
import JetActionMessage from "../../Jetstream/ActionMessage";
import JetButton from "../../Jetstream/Button";
import JetFormSection from "../../Jetstream/FormSection";
import JetInput from "../../Jetstream/Input";
import JetTextarea from "../../Jetstream/Textarea";
import JetProtectedTextarea from "../../Jetstream/ProtectedTextarea";
import JetAutoComplete from "../../Jetstream/AutoComplete";
import JetInputError from "../../Jetstream/InputError";
import JetLabel from "../../Jetstream/Label";
import JetSecondaryButton from "../../Jetstream/SecondaryButton";
import JetMaskedInput from "../../Jetstream/MaskedInput";
import JetFetchDoc from "../../Jetstream/FetchDoc";
import JetFetchCep from "../../Jetstream/FetchCep"
import Flash from "../../Helpers/Flash"
import ConfirmationModal from "../../Jetstream/ConfirmationModal";
import OkButton from "../../Jetstream/OkButton";
import _ from "lodash";
import OperatingLimits from './OperatingLimits.vue';

export default {
    props: ['errors', 'contact', 'routeBack'],
    methods: {
        create() {
            this.verifyLimits();
            this.addAccount();
            if (!this.canSave){
              return false;
            }
            const endpoint = this.contact.id ? `/contact/${this.contact.id}` : '/contact'
            this.form.post(endpoint, {
                preserveScroll: true,
                onError: (e) => {
                    this.form.processing = false;
                }
            });
        },

        remove() {
            const endpoint = `/contact/${this.contact.id}`;
            this.form._method = 'DELETE';
            this.form.post(endpoint, {
                preserveScroll: true,
                onError: (e) => {
                    this.form.processing = false;
                }
            });
        },
        removeAccount(index) {
            this.form.transfer_accounts.splice(index, 1);
        },
        editContact() {
            this.$inertia.get(this.route('contact.show', this.contactFound.id));
        },

        addAccount() {
            if (!this.newAccount.type) {
                return;
            }
            if (this.newAccount.type !== 'PIX') {
                if (!this.newAccount.bank) {
                    return;
                }
                if (!this.newAccount.agency) {
                    return;
                }
                if (!this.newAccount.number) {
                    return;
                }
            } else {
                if (!this.newAccount.key) {
                    return;
                }
            }
            this.checkAccount();
            this.$forceUpdate();
        },
        resetAccount() {
            this.newAccount = {
                type: null,
                bank: null,
                agency: null,
                number: null,
                name: null,
                key: null,
                typeKey: null,
            }
            this.invalidOwnership = false;
        },
        fetchDoc(content) {
            this.form.name = null;
            if (!content) {
                return;
            }
            if (content.hasOwnProperty('basic_data')) {
                this.form.name = content.basic_data.Name || content.basic_data.OfficialName;
            }else if (content.hasOwnProperty('data')){
                this.form.name = content.data.name;
            }
            this.checkDoc();
            this.$forceUpdate();
        },
        fetchCep(address) {
            this.form.address.street = null;
            this.form.address.neighborhood = null;
            this.form.address.city = null;
            this.form.address.state = null;

            if (!address) {
                return;
            }
            this.form.address.street = address.content.street || address.content.Officialstreet;
            this.form.address.neighborhood = address.content.neighborhood || address.content.Officialneighborhood;
            this.form.address.city = address.content.city || address.content.Officialcity;
            this.form.address.state = address.content.state || address.content.Officialstate;
            this.checkCep();
            this.$forceUpdate();
        },
        checkCep() {
            fetch(
                `/json/info/zip-code/check-cep?zip_code=${escape(this.form.address)}`
            ).then(res => {
                res.json().then(json => {
                    this.contactFound = json;
                });
            });
        },
        checkDoc() {
            fetch(
                `/json/contacts/check-doc?federal_document=${escape(this.form.federal_document)}`
            ).then(res => {
                res.json().then(json => {
                    this.contactFound = json;
                });
            });
        },
        checkAccount() {
            this.canSave = true;
            if(this.newAccount.bank) this.newAccount.bank.id = this.newAccount?.bank?.rawId;

            let validate = {
                checked: true,
                msg: "Essa conta já está cadastrada."
            }
            let accs = this.form.transfer_accounts.find(ac =>{
                if (this.newAccount.type === 'PIX'){
                    if (ac.key == this.newAccount.key){
                        return ac;
                    }
                }else{
                    if (ac.agency == this.newAccount.agency && ac.number == this.newAccount.number &&
                        (ac.bank.code == this.newAccount.bank.code || ac.bank.id == this.newAccount.bank.code)){
                            if (ac.type == this.newAccount.type || this.newAccount.type == this.whiteLabelShortName){
                                return ac;
                            }
                        }
                }
            });
            if (accs){
                this.resetAccount();
                validate.checked = false;
            }
            if (this.newAccount.type === 'PIX'){
                let verify = this.verifyKey();
                validate.checked = verify.checked;
                validate.msg = verify.msg || validate.msg;
            }
            if (!validate.checked){
                this.$toast.open({
                    message: validate.msg,
                    type: 'error',
                    duration: 5000,
                    position: 'top-right'
                });
                this.canSave = false;
                return;
            }
            if (this.newAccount.type !== this.whiteLabelShortName && this.newAccount.type !== 'PIX') {
                this.form.transfer_accounts.push({
                    type: this.newAccount.type || null,
                    bank: this.newAccount.bank || null,
                    agency: this.newAccount.agency || null,
                    number: this.newAccount.number || null,
                    name: this.newAccount.name || null,
                    key: this.newAccount.key || null,
                    typeKey: this.newAccount.typeKey || null,
                });
                this.resetAccount();
                return;
            }
            this.validating = true;

            let endPoint = (this.newAccount.type === this.whiteLabelShortName)
            ? `/json/contacts/check-account?number=${escape(this.newAccount.number)}&federal_document=${escape(this.form.federal_document)}`
            : `/json/contacts/check-pix?key=${escape(this.newAccount.key)}&typeKey=${this.keyTypeByName(this.newAccount.typeKey)}`

            fetch(
                endPoint
            ).then(res => {
                res.json().then(json => {
                    this.accountFound = json;
                    if (json.valid) {
                        delete this.newAccount.bank?.rawId;
                        this.form.transfer_accounts.push({
                            type: this.newAccount.type || null,
                            bank: this.newAccount.bank || null,
                            agency: this.newAccount.agency || null,
                            number: this.newAccount.number || null,
                            name: this.newAccount.name || null,
                            key: this.newAccount.key || null,
                            typeKey: this.newAccount.typeKey || null,
                        });
                        this.resetAccount();
                        this.validating = false;
                        return;
                    }
                    this.validating = false;
                    window.scrollTo(0, 0);
                    this.invalidOwnership = true;
                });
            });
        },
        verifyKey(){
            var key = (this.newAccount.typeKey != 'E-mail' && this.newAccount.typeKey != 'Aleatória')
            ? this.newAccount.key.replace(/\D/g,'')
            : this.newAccount.key;

            switch (this.newAccount.typeKey) {
                case 'CPF':
                    if (key.length !== 11){
                        return { checked: false, msg: "Chave CPF inválida."}
                    }
                    return { checked: true }
                case 'CNPJ':
                    if (key.length !== 14){
                        return { checked: false, msg: "Chave CNPJ inválida."}
                    }
                    return { checked: true }
                case 'Celular':
                    if (key.length !== 11){
                        return { checked: false, msg: "Chave Telefone inválida."}
                    }
                    return { checked: true }
                case 'Aleatória':
                    if (key.length !== 35){
                        return { checked: false, msg: "Chave Aleatória inválida."}
                    }
                    return { checked: true }
                case 'E-mail':
                    if (!key.includes('@')){
                        return { checked: false, msg: "Chave E-mail inválido."}
                    }
                    return { checked: true }
                default:
                    return { checked: true}
            }
        },
        keyTypeByName(type){
            switch (type) {
                case 'CPF':
                    return 0;
                case 'CNPJ':
                    return 1;
                case 'Celular':
                    return 2;
                case 'E-mail':
                    return 3;
                default:
                    return 4;
            }
        },
        verifyLimits() {
            this.canSave = true;
            this.formError = {
                "pix-own": null,
                "pix-others": null,
                "ted-own": null,
                "ted-others": null,
                "boleto-own": null,
                "boleto-others": null,
                "cash_in-own": null,
                "cash_in-others": null,
                "payments-own": null,
                "payments-others": null
            };
            let limits = Object.keys(this.form.limits).map(key => [
                key,
                this.form.limits[key]
            ]);
            for (let index = 0; index < limits.length; index++) {
                let limit = limits[index];
                let limitDaily = limit[1][0].quantity;
                if ("string" === typeof limitDaily) {
                    limitDaily = parseInt(limitDaily.replaceAll(".", ""));
                }
                let limitMonthly = limit[1][1].quantity;
                if ("string" === typeof limitMonthly) {
                    limitMonthly = parseInt(limitMonthly.replaceAll(".", ""));
                }
                if (limitDaily > limitMonthly) {

                    this.formError[limit[0]] = "O limite diario não pode ser maior que o mensal";
                    this.$forceUpdate();
                    this.canSave = false;
                    this.$nextTick(() => {
                         document.querySelector('#'+limit[0]).scrollIntoView({block: "center", behavior: 'smooth'});
                    });
                }
            }
        },
    },
    watch: {
        newAccount: {
            handler: _.debounce(function () {
                if (this.newAccount.type === this.whiteLabelShortName) {
                    this.newAccount.agency = '0001';
                    this.newAccount.typeKey = null;
                }
            }, 200),
            deep: true
        },
        errors: function (newE) {
            this.formError = newE;
        }
    },
    computed:{
        getBanks(){
            if(this.newAccount.type === this.whiteLabelShortName) {
                const bankCodes = ['274', '457', '529']
                return this.banks.filter(bank => bankCodes.includes(bank.code))
            }
            return this.banks.map((bank, index) => ({
                ...bank,
                rawId: bank.id,
                id: `${bank.bank_id}${index}`
            }));
        },
        errorOp: function (){
            return this.formError;
        },
        keyMask: function(){
            switch (this.newAccount.typeKey) {
                case 'CPF':
                    return ['###.###.###-##'];
                case 'CNPJ':
                    return ['##.###.###/####-##'];
                case 'Celular':
                    return ['(##) #####-####'];
                case 'Aleatória':
                    return ['XXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX'];
                default:
                    return [''];
            }
        }
    },
    async created(){
        const { data } = await axios.get('/json/banks')
        this.banks = data?.data ?? []
    },
    data() {
        return {
            whiteLabelShortName: this.$page.props.white_label.data.short_name ?? '2GO',
            invalidOwnership: false,
            validating: false,
            canSave: false,
            formError: {},
            banks: [],
            newAccount: {
                type: null,
                bank: null,
                agency: null,
                number: null,
                key: null,
                typeKey: null
            },
            contactFound: {
                id: null
            },
            accountFound: [],
            removalConfirm: false,
            flashIsVisible: true,
            stateList: ['AC', 'AL', 'AM', 'AP', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RO', 'RS', 'RR', 'SC', 'SE', 'SP', 'TO'].sort(),
            form: this.$inertia.form({
                _method: this.contact.id ? 'PUT' : 'POST',
                name:'',
                federal_document: null,
                transfer_accounts: [],
                address: {
                    zip_code: null,
                    street: null,
                    number: null,
                    complement: null,
                    neighborhood: null,
                    city: null,
                    state: null,
                },
                ...this.contact
            }, {
                resetOnSuccess: false,
            }),
        }
    },
    components: {
        OkButton,
        ConfirmationModal,
        AppLayout,
        Flash,
        JetAutoComplete,
        JetSectionBorder,
        JetActionMessage,
        JetButton,
        JetFormSection,
        JetInput,
        JetTextarea,
        JetProtectedTextarea,
        JetInputError,
        JetLabel,
        JetSecondaryButton,
        JetMaskedInput,
        JetFetchDoc,
        JetFetchCep,
        OperatingLimits

    }
}
</script>
